<template>
  <symbol
    id="twitter-outline"
    viewBox="0 0 24 24"
  >
    <path d="M13.294 10.928L18.357 5H17.157L12.762 10.147L9.24995 5H5.19995L10.51 12.784L5.19995 19H6.39995L11.042 13.564L14.751 19H18.801L13.294 10.928ZM11.651 12.852L11.113 12.077L6.83195 5.91H8.67495L12.129 10.887L12.667 11.662L17.158 18.132H15.315L11.651 12.852Z" />
  </symbol>
</template>
